import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
// import CustomModal from 'src/components/containers/CustomModal'
// import {FuneralHome} from 'src/resources'
import {
  ConfiguratorBox,
  VerticalAlignWrapper
} from 'src/components/containers/configurator/ConfiguratorBox'
// import MoreInfo from 'src/components/atoms/input/buttons/MoreInfo'
import { ConfiguratorText } from 'src/components/atoms/configurator'
import { StoreProps } from 'src/stores'
import { media } from 'src/utils.js'
// import Link from '../../atoms/input/buttons/Link'
// import ReactHtmlParser from 'react-html-parser';

type Props = StoreProps

interface State {
  fhModalOpen: boolean
  sharingModalOpen: boolean
}

@inject('adminStore')
@observer
export default class ClientDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      fhModalOpen: false,
      sharingModalOpen: false
    }
  }

  toggleFHModal = () => {
    const { fhModalOpen } = this.state
    this.setState({ fhModalOpen: !fhModalOpen })
  }

  toggleSharingModal = () => {
    const { sharingModalOpen } = this.state
    this.setState({ sharingModalOpen: !sharingModalOpen })
  }

  planningReasonName = (planningReason) => {
    switch (planningReason) {
      case 'ACUTE_BEREAVEMENT':
        return 'Eingetretener Trauerfall'
      case 'IMPENDING_BEREAVEMENT':
        return 'Bevorstehender Trauerfall'
      case 'PROVISION':
        return 'Bestattungsvorsorge'
      default:
        return 'Ungültig!'
    }
  }

  contactDetails = () => {
    const { adminStore } = this.props
    const order = adminStore.getOrder
    //console.log('Contact Details: ', order.contactDetails)
    return (
      <>
        <DetailLine>
          {order.contactDetails.greeting === 'MRS' ? 'Frau' : 'Herr'}
        </DetailLine>
        <DetailLine>
          <span id='contactName'>{order.contactDetails.firstName} {order.contactDetails.lastName}</span>
        </DetailLine>
        <DetailLine>E: <span id='contactEmail'>{order.contactDetails.email}</span></DetailLine>
        <DetailLine>T: <span id='contactPhone'>{order.contactDetails.phone}</span></DetailLine>
      </>
    )
  }

  enterContactDetailsClaim = () => {
    // const { adminStore } = this.props
    return (
      <>
        <ConfiguratorText>Fügen Sie Ihre Kontaktdaten</ConfiguratorText>
        <ConfiguratorText>hinzu und vervollständigen</ConfiguratorText>
        <ConfiguratorText>Sie Ihre Planung.</ConfiguratorText>
        {/* <VerticalAlignWrapper>
          <Link light onClick={() => adminStore.setContactDetailsPopup(true)}>
            Kontakt hinzufügen
          </Link>
        </VerticalAlignWrapper> */}
      </>
    )
  }

  render() {
    const { adminStore } = this.props
    // const { fhModalOpen, sharingModalOpen } = this.state
    const order = adminStore.getOrder
    // const funeralHome = adminStore.getCatalogue.funeralHome

    return (
      <ConfiguratorBox
        title='Ihr Angebot'
        style={{ gridArea: 'planning', marginBottom: '15px' }}
        actionIcon='fa-share-alt'
        actionIconOnClick={this.toggleSharingModal}>
        <DetailContainer>
          <ContactDetailsContainer>
            <DetailBoxHeader>
              <VerticalAlignWrapper>
                <p>Kundendaten</p>
              </VerticalAlignWrapper>
            </DetailBoxHeader>
            {order.contactDetails.firstName === ''
              ? this.enterContactDetailsClaim()
              : this.contactDetails()}
          </ContactDetailsContainer>

          <div>
            <DetailBoxHeader>
              <p>Angebotsdetails</p>
            </DetailBoxHeader>
            <ConfiguratorText>
              {this.planningReasonName(order.planningReason)}
            </ConfiguratorText>
            <ConfiguratorText>Angebot: {order.orderId}</ConfiguratorText>
            <ConfiguratorText>Datum: {order.creationDate}</ConfiguratorText>
            <ConfiguratorText>
              Ort:{' '}
              {order.location.label
                ? order.location.label
                : order.location.city}
            </ConfiguratorText>
          </div>

          <div>
            <DetailBoxHeader>
              <p>Ansprechpartner</p>
            </DetailBoxHeader>
            <ConfiguratorText>
              {order.customerAgent != null && order.customerAgent.name != null
                ? order.customerAgent.name
                : 'Stefan Atz'}
            </ConfiguratorText>
            <ConfiguratorText>
              T: <a href='tel:+4319076885'>01 907 68 85</a>
            </ConfiguratorText>
            <ConfiguratorText>
              E: <a href='mailto:kontakt@benu.at'>kontakt@benu.at</a>
            </ConfiguratorText>
            <ConfiguratorText />
          </div>
        </DetailContainer>
        {/* <FuneralHomeInfo show={!!funeralHome}>
          <p>Unser Partner vor Ort:</p>
          <FuneralHomeName onClick={this.toggleFHModal}>
            {!!funeralHome && <p>{funeralHome.name}</p>}
            <InlineInfoIcon />
          </FuneralHomeName>
        </FuneralHomeInfo> */}
      </ConfiguratorBox>
    )
  }
}
const DetailContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 15px;
  justify-content: space-around;
  margin: 15px 30px;
  padding: 0;
  ${media.tablet` justify-content: unset; `}
`

const DetailBoxHeader = styled.div`
  margin-bottom: 7.5px;
  p {
    margin: 0;
    font-weight: bold;
    font-size: 18px;
    ${media.phone`font-size: 16px;`}
  }
`
const ContactDetailsContainer = styled.div`
  /* ${media.largePhone`display: none;`} */
`

const DetailLine = styled(ConfiguratorText)`
  line-height: 1.15;
`

// const FuneralHomeInfo = styled.div`
//   display: flex;
//   align-items: baseline;
//   flex-wrap: wrap;
//   margin: 0 30px;
//   margin-bottom: 15px;
//   font-size: 16px;
//   & > * {
//     margin-right: 7.5px;
//   }
//   & > p {
//     margin-bottom: 0;
//     font-size: 18px;
//     font-weight: bold;
//     ${media.phone`font-size: 16px;`}
//   }
//   ${(props) => !props.show && 'display: none;'}
// `

// const FuneralHomeName = styled(VerticalAlignWrapper)`
//   cursor: pointer;
//   color: #9abbbf;
//   & > p {
//     font-size: 16px;
//     margin: 0;
//   }
// `

// const InlineInfoIcon = styled(MoreInfo)`
//   position: unset;
//   width: 23px;
//   height: 23px;
//   margin: 0 7.5px;
// `



// WEBPACK FOOTER //
// ./src/components/organisms/admin/ClientDetails.tsx